import React, { lazy } from "react";

const LazyChatbot = lazy(() => import("./Chatbot"));

const Chatbot = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyChatbot {...props} />;

export default Chatbot;
